export const addTranslationValue = (languages, values, getKeyFrom) => {
  const translations = {};
  Object.values(languages).map((item: any) => {
    translations[item.code] = values[`${getKeyFrom}[${item.code}]`];
  });
  return translations;
};
